import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MainHeaderComponent } from './common_components/main-header/main-header.component';
import { MainMenuComponent } from './common_components/main-menu/main-menu.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { OnlyNumbersDirective } from './Directives/only-numbers.directive';
import { AttachmentComponent } from '../layout/producer-group/components/attachment/attachment.component';
import { FooterComponent, GridModule } from '@progress/kendo-angular-grid';
import { DownloadDirective } from './Directives/download.directives';
import { TooltipModule } from "@progress/kendo-angular-tooltip";
import { DeleteConfirmationComponent } from './common_components/delete-confirmation/delete-confirmation.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatOptionModule, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatListModule } from '@angular/material/list';
import { MainFooterComponent } from './common_components/main-footer/main-footer.component';
import { TwoDigitDecimaNumberDirective } from './Directives/twodigitdecimal.directives';
import { ToasterComponent } from './common_components/toaster/toaster.component';
import { AddEditProductMasterComponent } from './common_components/add-edit-product-master/add-edit-product-master.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {NgxSpinnerModule} from 'ngx-spinner';
import { CommonAttachmentComponent } from './common_components/common-attachment/common-attachment.component';
import { CertificateComponent } from './common_components/certificate/certificate.component'
import { NgxPrintModule } from 'ngx-print';
import { OnlyAlphabetDirective } from './Directives/only-aphabet.directive';
import { IdProofComponent } from './common_components/id-proof/id-proof.component';
import { BPOnlyNumbersDirective } from './Directives/BPNumber.directive';
import { QRCodeModule } from 'angular2-qrcode';
import { BlockCopyPasteDirective } from './Directives/cut-copy-paste.directives';
import { DebounceClickDirective } from './Directives/doubleclick.directive';
import { ContinueConfirmationComponent } from './common_components/continue-confirmation/continue-confirmation.component';
import { MaskPipe } from './Pipes/mask.pipes';
const MODULE = [
    FontAwesomeModule,
    TooltipModule,
    BsDatepickerModule.forRoot(),
    GridModule,
    TooltipModule,
    QRCodeModule
];

const FORM_MODULE = [
  ReactiveFormsModule,
  FormsModule,
  TranslateModule,
];

const COMPONENTS = [
  MainHeaderComponent,
  MainMenuComponent,
  DeleteConfirmationComponent,
  MainFooterComponent,
  AddEditProductMasterComponent,
  CertificateComponent
];

const DIRECTIVES = [
OnlyNumbersDirective,
DownloadDirective,
TwoDigitDecimaNumberDirective,
OnlyAlphabetDirective,
BPOnlyNumbersDirective,
BlockCopyPasteDirective,
DebounceClickDirective,
MaskPipe
];

const MATERIAL_MODULE = [
  NgxSpinnerModule,
  MatBadgeModule,
  MatIconModule,
  MatTreeModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatStepperModule,
  MatSortModule,
  MatRippleModule,
  MatCheckboxModule,
  MatCheckboxModule,
  MatButtonModule,
  MatInputModule,
  MatAutocompleteModule,
  MatDatepickerModule,
  MatFormFieldModule,
  MatRadioModule,
  MatSelectModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatMenuModule,
  MatSidenavModule,
  MatToolbarModule,
  MatListModule,
  MatGridListModule,
  MatCardModule,
  MatTabsModule,
  MatExpansionModule,
  MatButtonToggleModule,
  MatChipsModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatDialogModule,
  MatTooltipModule,
  MatSnackBarModule,
  MatTableModule,
  MatOptionModule,
  RouterModule,
  NgxPrintModule
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ...FORM_MODULE,
    ...MODULE,
    ...MATERIAL_MODULE,
  ],
  declarations: [
    ...COMPONENTS,
    ...DIRECTIVES,
    ToasterComponent,
    CommonAttachmentComponent,
    IdProofComponent,
    ContinueConfirmationComponent,
  ],
  exports: [
    ...FORM_MODULE,
    ...COMPONENTS,
    ...DIRECTIVES,
    ...MATERIAL_MODULE,
  ],
  entryComponents: [],

})
export class ThemeModule { }
